import React from 'react';
import { compose } from 'redux';
import { Box, ModalProps } from '@material-ui/core';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { FieldArray, reduxForm, getFormValues } from 'redux-form/immutable';
import { useSelector, useDispatch } from 'react-redux';

import { Modal, ModalContents, ModalTitle, ModalButton } from 'components/Modal/Modal';
import FormNonprofitsSelectorRedesign from 'retired/FormNonprofitsSelectorRedesign';
import countries from 'utils/countries';

import { UNBLOCK_NONPROFIT_NONPROFIT_FORM_IDENTIFIER, unblockNonprofitAction } from './types';

const UnblockNonprofitModal = ({
  onClickClose,
  style,
  ...props
}: {
  onClickClose: () => void;
} & ModalProps): JSX.Element => {
  const dispatch = useDispatch();
  const formValues = useSelector(getFormValues(UNBLOCK_NONPROFIT_NONPROFIT_FORM_IDENTIFIER));

  const data = formValues?.get('nonprofits').toJS();
  const nonprofitId = data && data[0]?.id;

  return (
    <Modal
      disableAutoFocus
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      {...props}
    >
      <ModalContents
        onClickClose={onClickClose}
        body={
          <>
            <ModalTitle>Unblock a nonprofit</ModalTitle>
            <Box paddingTop={4}>
              <form>
                <FieldArray
                  name="nonprofits"
                  component={FormNonprofitsSelectorRedesign}
                  fullWidth
                  autoFocus
                  required
                  limit={1}
                  initialLocation={countries.US.alpha2}
                  variant="standard"
                  locationSelectorLabel="Organization country"
                  locationSelectorPlaceholder="Enter their operating country"
                  nonprofitSelectorLabel="Organization name"
                  nonprofitSelectorPlaceholder="Search by their name or Employer Identification Number (EIN)"
                />
              </form>
            </Box>
          </>
        }
        actions={
          <>
            <ModalButton
              variant="outlined"
              onClick={(): void => {
                onClickClose();
              }}
            >
              Cancel
            </ModalButton>
            &nbsp;
            <ModalButton
              disabled={!nonprofitId}
              type="submit"
              onClick={(): void => {
                dispatch(unblockNonprofitAction(nonprofitId));
                onClickClose();
              }}
              endIcon={<LockOpenIcon />}
            >
              Unblock
            </ModalButton>
          </>
        }
      />
    </Modal>
  );
};

const withForm = reduxForm({
  form: UNBLOCK_NONPROFIT_NONPROFIT_FORM_IDENTIFIER,
  enableReinitialize: true,
});

export default compose(withForm)(UnblockNonprofitModal);
